module.exports = __webpack_public_path__ + "static/BakingBanner-02-544b459e35b26f619ad521351b8cc856.png";